import { Trans, useTranslation } from "react-i18next";

const Error404 = () => {
  const { t } = useTranslation();


  return (
    <>
      <h1 className='fw-bolder fs-3 text-gray-700 mb-10'>{t('PageNotFound')}</h1>
       <div className='fw-bold fs-5 text-gray-400 mb-15'>
        <Trans i18nKey="PageNotFoundText" components={{ br: <br/> }} />
       </div>
    </>
  );
};

export default Error404;